<script setup lang="ts">
interface Props {
  icon?: string
  title: string
  description?: string
}

withDefaults(defineProps<Props>(), {
  icon: '📭',
})
</script>

<template>
  <div class="aw-empty">
    <div class="aw-empty__icon">{{ icon }}</div>
    <div class="aw-empty__title">{{ title }}</div>
    <div v-if="description" class="aw-empty__desc">{{ description }}</div>
    <div v-if="$slots.action" class="aw-empty__action">
      <slot name="action" />
    </div>
  </div>
</template>

<style scoped>
.aw-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--aw-space-12) var(--aw-space-6);
  text-align: center;
}
.aw-empty__icon {
  font-size: 64px;
  line-height: 1;
  margin-bottom: var(--aw-space-4);
}
.aw-empty__title {
  font-size: var(--aw-text-base);
  font-weight: var(--aw-font-medium);
  color: var(--aw-text-primary);
  margin-bottom: var(--aw-space-2);
}
.aw-empty__desc {
  font-size: var(--aw-text-sm);
  color: var(--aw-text-secondary);
  margin-bottom: var(--aw-space-4);
  max-width: 400px;
}
.aw-empty__action {
  margin-top: var(--aw-space-2);
}
</style>